import { styled } from "styled-components";

import { colorCSS } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

export const Button = styled.a`
    ${redundantCssFromKebab("align-items", "center")}
    ${redundantCssFromKebab("align-self", "stretch")}
    ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("font-size", "1.2rem")}
    ${redundantCssFromKebab("height", "100%")}
    ${redundantCssFromKebab("padding", "0.5rem 1.5rem")}
    ${redundantCssFromKebab("text-decoration", "none")}

    &:hover {
        ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
    }
`;

export const PrimaryButton = styled(Button)`
    ${redundantCssFromKebab("background-color", colorCSS("B300"))}
    ${redundantCssFromKebab("color", `${colorCSS("N0")} !important`)}

    &:hover {
        ${redundantCssFromKebab("background-color", colorCSS("B500"))}
        ${redundantCssFromKebab("color", `${colorCSS("N0")} !important`)}
    }
`;

export const PrimaryButtonDark = styled(Button)({
    "backgroundColor": colorCSS("N800"),
    "color": `${colorCSS("N0")} !important`,
    "&:hover": {
        "backgroundColor": colorCSS("N400"),
        "background-color": colorCSS("N400")
    },
    "&:active": {
        "backgroundColor": colorCSS("N100"),
        "background-color": colorCSS("N100")
    }
});

export const ButtonGroup = styled.div`
    ${redundantCssFromKebab("align-items", "stretch")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("margin-left", "auto")}
`;
